import { createContext } from "react";

interface ProduceParams {
	batchId: string;
	alias: string | undefined;
}

export interface OrdersContextProps {
	scanToTriggerConfigured: boolean;
	scanToTriggerSingleConfigured: boolean;
	triggerJobByLPN: (machineGroupId: string, _lpn: string) => void;
	triggerSingleJob: (batchId: string) => void;
	removeJob: (batchId: string) => void;
	produceNext: (params: ProduceParams) => void;
	produceNow: (params: ProduceParams) => void;
}

export const initialOrdersContextValues: OrdersContextProps = {
	scanToTriggerConfigured: false,
	scanToTriggerSingleConfigured: false,
	triggerJobByLPN: () => {},
	triggerSingleJob: () => {},
	removeJob: (_bathId) => {},
	produceNext: () => {},
	produceNow: () => {},
};

export const OrdersContext = createContext(initialOrdersContextValues);
